'use client'

import { MultiChoiceWordQuestion, PronounceRuby } from '@entities/lesson'
import React from 'react'
import { match } from 'ts-pattern'

import { Typography } from '@podo-app/design-system-temp'

type Props = {
  question: MultiChoiceWordQuestion
  highlightText: (text: string, highlightTarget: string) => React.ReactNode
}

export const EnglishMultiChoiceWordHintFunnel = ({ question, highlightText }: Props) => {
  return (
    <React.Fragment>
      <Typography size="h3" className="font-medium">
        {highlightText(question.source.hint.sentence, question.source.hint.highlight)}
      </Typography>
      <Typography size="body1" className="text-gray-500">
        {question.source.hint.sentence_translation}
      </Typography>
    </React.Fragment>
  )
}

export const JapaneseMultiChoiceWordHintFunnel = ({ question, highlightText }: Props) => {
  return (
    <React.Fragment>
      <Typography size="h3" className="font-medium font-noto-jp break-all">
        {match(question.content_level)
          .when(
            (level) => level === 2,
            () =>
              question.source.hint.sentence_diction_native_lang ? (
                <PronounceRuby
                  text={highlightText(question.source.hint.sentence, question.source.hint.highlight)}
                  translation={question.source.hint.sentence_diction_native_lang}
                  className="!text-[9px]"
                />
              ) : (
                highlightText(question.source.hint.sentence, question.source.hint.highlight)
              ),
          )
          .otherwise(() => highlightText(question.source.hint.sentence, question.source.hint.highlight))}
      </Typography>
      <Typography size="body1" className="text-gray-500">
        {question.source.hint.sentence_translation}
      </Typography>
    </React.Fragment>
  )
}
